<ng-container *ngIf="rebookingState$ | async as state">
    <h1 mat-dialog-title class="active">
        {{ "app.dialog.bab-rebooking.title.header.label" | translate }}
    </h1>
    <div mat-dialog-content>
        <mat-generic-input
            (inputFormGroupChange)="onSourceFormgroupChange($event)"
            [fields]="layout.sourceFields"
            [initialValue]="initialSourceData | async">
        </mat-generic-input>

        <div class="distributionBalance">
            <span>{{"app.dialog.rebooking.before.label" | translate}}: {{(data.costCt / 100) | number: '1.2-2' : 'de-DE' }} €</span>
            <span>{{"app.dialog.rebooking.after.label" | translate}}: {{((data.costCt - (rebookingValueCt | async)) / 100) | number: '1.2-2' : 'de-DE' }} €</span>
        </div>

        <mat-divider class="sectionDivider"></mat-divider>

        <mat-generic-input
            (inputFormGroupChange)="onTargetFormgroupChange($event)"
            [fields]="layout.targetFields">
        </mat-generic-input>

        <div class="distributionBalance">
            <span>{{"app.dialog.rebooking.before.label" | translate}}: {{((targetValueBefore | async) / 100) | number: '1.2-2' : 'de-DE' }} €</span>
            <span>{{"app.dialog.rebooking.after.label" | translate}}: {{(((targetValueBefore | async) + (rebookingValueCt | async)) / 100) | number: '1.2-2' : 'de-DE' }} €</span>
        </div>

    </div>
    <div mat-dialog-actions>
        <button mat-stroked-button mat-dialog-close (click)="close()">{{ "app.button.cancel.label" | translate }}</button>
        <button
            mat-flat-button
            color="primary"
            [disabled]="!(targetSelected | async) || (rebookingValueCt | async) === 0"
            (click)="save()">{{ "app.button.save.label" | translate }}</button>
    </div>
</ng-container>
